import { EnforcementInfo, KMLEntry } from '../../../interfaces';
import { Enforce } from './Enforce';

export const getEnforceStatus = (obj: Partial<EnforcementInfo>): Enforce | null => {
  if (!obj) {
    return null; // failsafe to not crash the app
  }

  if (obj.enforce_start === 0 && obj.enforce_end === 0) {
    return Enforce.never;
  }

  if (obj.enforce_start === 0 && obj.enforce_end === 24 && obj.enforce_days?.length === 7) {
    return Enforce.always;
  }

  if (Number.isFinite(obj.enforce_start) || Number.isFinite(obj.enforce_end)) {
    return Enforce.hours;
  }

  return null;
};

export const getColorByStatus = (point: KMLEntry): string => {
  const status = getEnforceStatus(point);
  if (status === Enforce.always) {
    return '#028e02';
  }
  if (status === Enforce.hours) {
    return '#298fc8';
  }
  if (status === Enforce.never) {
    return '#c91900';
  }

  return '#7f7f7f';
};
